import { render, staticRenderFns } from "./AgencyItem.vue?vue&type=template&id=a1f1f946&scoped=true"
import script from "./AgencyItem.vue?vue&type=script&lang=js"
export * from "./AgencyItem.vue?vue&type=script&lang=js"
import style0 from "./AgencyItem.vue?vue&type=style&index=0&id=a1f1f946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1f946",
  null
  
)

export default component.exports